import { render, staticRenderFns } from "./CompassIndustry.vue?vue&type=template&id=c3b84db6&"
import script from "./CompassIndustry.vue?vue&type=script&lang=ts&"
export * from "./CompassIndustry.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports